import styled from "styled-components";

const S = {};

const BetSlipCheckBackground = ({ theme: { $betSlipCheckBackgroundColor } }) => `${$betSlipCheckBackgroundColor}`;
const BetSlipCheckHeaderColor = ({ theme: { $betSlipCheckHeaderColor } }) => `${$betSlipCheckHeaderColor}`;
const BetSlipCheckHeaderBackground = ({ theme: { $betSlipCheckHeaderBackground } }) => `${$betSlipCheckHeaderBackground}`;
const BetSlipCheckBodyContentBackground = ({ theme: { $betSlipCheckBodyContentBackground } }) => `${$betSlipCheckBodyContentBackground}`;
const BetSlipCheckLabelColor = ({ theme: { $betSlipCheckLabelColor } }) => `${$betSlipCheckLabelColor}`;
const BetSlipCheckInputColor = ({ theme: { $betSlipCheckInputColor } }) => `${$betSlipCheckInputColor}`;
const BetSlipCheckInputBackground = ({ theme: { $betSlipCheckInputBackground } }) => `${$betSlipCheckInputBackground}`;
const BetSlipCheckInputBorderColor = ({ theme: { $betSlipCheckInputBorderColor } }) => `${$betSlipCheckInputBorderColor}`;
const BetSlipCheckButtonColor = ({ theme: { $betSlipCheckButtonColor } }) => `${$betSlipCheckButtonColor}`;
const BetSlipCheckButtonBackground = ({ theme: { $betSlipCheckButtonBackground } }) => `${$betSlipCheckButtonBackground}`;
const BetSlipCheckButtonTextFont = ({ theme: { $betSlipCheckButtonTextFont } }) => `${$betSlipCheckButtonTextFont}`;

S.BetSlipCheck = styled.form`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    overflow: hidden;
    background-color: ${BetSlipCheckBackground};
    ${({ theme: { boxShadow } }) => boxShadow()};
`;

S.BetSlipCheckHeader = styled.div`
    width: 100%;
    padding: 1rem 0.5rem;
    font-size: 1.4rem;
    color: ${BetSlipCheckHeaderColor};
    background-color: ${BetSlipCheckHeaderBackground};
`;

S.BetSlipCheckHeaderTitle = styled.span``;

S.ArrowIcon = styled.i`
    margin-left: auto;
    margin-right: 0.5rem;
`;

S.BetSlipCheckBody = styled.div`
    position: relative;
    max-height: 1000px;
    transition-property: max-height;
    transition-duration: .5s;
    ${({ visible }) => {
        return visible == false && 'max-height: 0';
    }}
`;

S.BetSlipCheckContent = styled.div`
    background: ${BetSlipCheckBodyContentBackground};
    padding: 0.8333rem;
    ${({ theme: { boxShadow } }) => boxShadow()};
`;

S.FormGroupWrapper = styled.div`
    margin-bottom: 20px;
`;

S.Label = styled.label`
    margin-top: 0.25rem;
    font-size: 1.3rem;
    color: ${BetSlipCheckLabelColor};
    font-weight: normal;
    margin: 0 auto 0.8333rem;
    width: 100%;
`;

S.Input = styled.input`
    font-size: 1.3333rem;
    text-align: right;
    background-color: transparent;
    border: none;
    padding-right: 0.5rem;
    width: 100%;
    color: ${BetSlipCheckInputColor};
    background-color: ${BetSlipCheckInputBackground};
    border: 1px solid ${BetSlipCheckInputBorderColor};
    border-radius: 4px;
    height: 2.7rem;
    padding: 0.5rem 1rem;
`;

S.Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    font-size: 1.3333rem;
    color: ${BetSlipCheckButtonColor};
    background-color: ${BetSlipCheckButtonBackground};
    height: 4.5rem;
    border: none;
    border-radius: 5px;
    text-align: center;
    width: 12.3333rem;
    text-transform: uppercase;
    font-family: ${BetSlipCheckButtonTextFont};
`;


S.BetSlipCheckFooter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    flex-wrap: wrap;
`;

S.Error = styled.div`
    width: 100%;
    text-align: center;
    font-size: 1.5rem;
    color: #262626;
    background-color: red;
    margin-top: 0.5rem;
    font-weight: bold;
    height: 3.5rem;
    line-height: 3.5rem;
`;

export default S;
